import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <main className="shop-main">
        <section className="shop-head">
          <h2 className="shop-title">Shop All</h2>
          <p className="shop-sub">
            Shop all Rivergrove{" "}
            <Link to="/shop" onClick={toTop} className="shop-link">
              cameras
            </Link>
            ,{" "}
            <Link to="/shop" onClick={toTop} className="shop-link">
              doorbells
            </Link>
            ,{" "}
            <Link to="/shop" onClick={toTop} className="shop-link">
              security systems
            </Link>
            ,{" "}
            <Link to="/shop" onClick={toTop} className="shop-link">
              accessories
            </Link>{" "}
            and the all-new{" "}
            <Link to="/shop" onClick={toTop} className="shop-link">
              Rivergrove Sensors
            </Link>
            .
          </p>
        </section>

        <section className="shop-section">
          <h3 className="shop-section-title">Best Sellers</h3>
          <div className="shop-grid">
            {productData.map((p, idx) => {
              const price = Number(p.price);
              const oldPrice = (price + (idx % 2 === 1 ? 19 : 0)).toFixed(2);
              const badges =
                [
                  ["New", "Best Seller"],
                  ["Best Seller", "Save €19"],
                  ["Best Seller"],
                  ["Best Seller", "Retinal 2K"],
                ][idx % 4] || [];
              const hasOld = badges.some((b) => b.includes("Save"));
              return (
                <Link
                  to={`/shopDetails/${p.id}`}
                  className="shop-card"
                  key={p.id}
                  onClick={toTop}
                >
                  <div className="shop-card-badges">
                    {badges.map((b, i) => (
                      <span
                        className={
                          "chip " +
                          (b.includes("Save")
                            ? "chip--warning"
                            : b.includes("Retinal")
                            ? "chip--success"
                            : "chip--primary")
                        }
                        key={i}
                      >
                        {b}
                      </span>
                    ))}
                  </div>
                  <div className="shop-card-media">
                    <img src={p.image} alt={p.name} />
                  </div>
                  <div className="shop-card-body">
                    <h4 className="shop-card-name">{p.name}</h4>
                    <div className="shop-card-sub">Plug-In</div>
                    <div className="shop-price">
                      <span className="shop-price-now">
                        Starting at €{price.toFixed(2)}
                      </span>
                      {hasOld && (
                        <span className="shop-price-old">€{oldPrice}</span>
                      )}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
